import { createSelector } from 'reselect';

import { pluralize } from 'utils/format';
import { formatServings } from 'utils/product';

import { getProductById } from 'redux/modules/entities/selectors/products';

export const getEntertainingAttributes = createSelector([getProductById], product => {
  if (!product) return null;

  const { leadTime, servings } = product;

  return leadTime || servings
    ? {
        servings: servings ? formatServings(servings) : null,
        leadTime: leadTime && leadTime > 0 ? pluralize(leadTime, 'day') : null,
      }
    : null;
});
